<app-header [breadcrumbs]="['Dashboard']" mainHeading="Dashboard" />
<div class="dashboard-container">
    <ng-container *ngIf="loading(); else loadedContent">
        <app-dashboard-table-skeleton />
    </ng-container>

    <ng-template #loadedContent>

        @if ((user()?.commissioner)) {
            <div class="dashboard-stats-container">
                <app-count-open-packages />
                <app-count-offered-packages />
                <app-count-not-interested-packages />
                <app-count-requested-packages />
                <app-count-rejected-packages />
            </div>
        }

        @if ((user()?.provider)) {
            <div class="dashboard-stats-container">
                <app-count-provider-owned-packages />
                <app-count-available-to-request />
            </div>
        }

        <div>
            <h2 class="open-assignments-title">Available To Request Packages</h2>
        </div>

        @if (regions$ | async; as result) {
            @if (result.regions.length > 0) {
                <div class="dashboard-tables-container">
                    @if(packages$ | async; as packages){
                        <app-dashboard-summary-table
                            title="All open packages"
                            subTitle="In order of creation date."
                            [packages]=packages
                            (countdownComplete)="onCountdownComplete()"
                        />
                    }

                    @for (region of result.regions; track region.id) {
                        @for (priority of Object.values(region.priorities); track priority.id) {
                            @if (priority.packages.length > 0) {
                                <app-dashboard-stats-table title="{{ region.region_name }}"
                                                           priority="{{ priority.priority_name }}"
                                                           subTitle="{{ priority.priority_description }}"
                                                           [packages]=priority.packages
                                                           (countdownComplete)="onCountdownComplete()"/>

                            }
                        }
                    }
                </div>
            } @else {
                <div class="no-data-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                        <mask id="mask0_4489_5266" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                              width="61" height="60">
                            <rect x="0.5" width="60" height="60" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_4489_5266)">
                            <path
                                d="M15.3556 53.75C14.3752 53.75 13.5292 53.3942 12.8175 52.6825C12.1058 51.9708 11.75 51.1248 11.75 50.1444V9.85563C11.75 8.87521 12.1058 8.02917 12.8175 7.3175C13.5292 6.60583 14.3752 6.25 15.3556 6.25H35.4281C35.9565 6.25 36.4554 6.36062 36.925 6.58187C37.395 6.80312 37.8015 7.12208 38.1444 7.53875L48.3606 19.3556C48.6719 19.6944 48.8979 20.064 49.0387 20.4644C49.1796 20.8648 49.25 21.2837 49.25 21.7212V49.0194C49.25 49.8202 48.8806 50.369 48.1419 50.6656C47.4031 50.9623 46.75 50.8269 46.1825 50.2594L35.2644 39.3175C34.4631 39.8333 33.6854 40.1915 32.9313 40.3919C32.1775 40.5923 31.3671 40.6925 30.5 40.6925C28.2125 40.6925 26.2817 39.9054 24.7075 38.3312C23.1333 36.7571 22.3463 34.8263 22.3463 32.5387C22.3463 30.2508 23.1333 28.3198 24.7075 26.7456C26.2817 25.1719 28.2125 24.385 30.5 24.385C32.7875 24.385 34.7183 25.1719 36.2925 26.7456C37.8667 28.3198 38.6538 30.2508 38.6538 32.5387C38.6538 33.4429 38.5223 34.294 38.2594 35.0919C37.9965 35.8894 37.6102 36.6135 37.1006 37.2644L46.4131 46.6013V21.2931L35.9038 9.08688H15.3556C15.1635 9.08688 14.9873 9.16687 14.8269 9.32687C14.6669 9.48729 14.5869 9.66354 14.5869 9.85563V50.1444C14.5869 50.3365 14.6669 50.5127 14.8269 50.6731C14.9873 50.8331 15.1635 50.9131 15.3556 50.9131H40.5C40.96 50.9131 41.305 51.0594 41.535 51.3519C41.765 51.644 41.88 51.9654 41.88 52.3162C41.88 52.6667 41.7608 52.9931 41.5225 53.2956C41.2846 53.5985 40.9438 53.75 40.5 53.75H15.3556ZM30.5 37.8556C32.0354 37.8556 33.3054 37.2771 34.31 36.12C35.315 34.9629 35.8175 33.604 35.8175 32.0431C35.8175 30.6681 35.2919 29.5208 34.2406 28.6012C33.1894 27.6813 31.9425 27.2212 30.5 27.2212C29.0575 27.2212 27.8106 27.6813 26.7594 28.6012C25.7081 29.5208 25.1825 30.6681 25.1825 32.0431C25.1825 33.604 25.685 34.9629 26.69 36.12C27.6946 37.2771 28.9646 37.8556 30.5 37.8556Z"
                                fill="#1C1B1F" />
                        </g>
                    </svg>
                    <span class="no-data-heading">Your dashboard is currently empty</span>
                    <div class="sub-heading-group">
                        <span class="no-data-sub-heading">There’s currently no information to display for your account. When data becomes available, it will appear on this dashboard.</span>
                        <span class="no-data-sub-heading">If you believe this is an error, please contact your administrator.</span>
                    </div>
                </div>
            }
        } @else {
            <div class="no-data-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                    <mask id="mask0_4489_5266" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="61" height="60">
                        <rect x="0.5" width="60" height="60" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_4489_5266)">
                        <path
                            d="M15.3556 53.75C14.3752 53.75 13.5292 53.3942 12.8175 52.6825C12.1058 51.9708 11.75 51.1248 11.75 50.1444V9.85563C11.75 8.87521 12.1058 8.02917 12.8175 7.3175C13.5292 6.60583 14.3752 6.25 15.3556 6.25H35.4281C35.9565 6.25 36.4554 6.36062 36.925 6.58187C37.395 6.80312 37.8015 7.12208 38.1444 7.53875L48.3606 19.3556C48.6719 19.6944 48.8979 20.064 49.0387 20.4644C49.1796 20.8648 49.25 21.2837 49.25 21.7212V49.0194C49.25 49.8202 48.8806 50.369 48.1419 50.6656C47.4031 50.9623 46.75 50.8269 46.1825 50.2594L35.2644 39.3175C34.4631 39.8333 33.6854 40.1915 32.9313 40.3919C32.1775 40.5923 31.3671 40.6925 30.5 40.6925C28.2125 40.6925 26.2817 39.9054 24.7075 38.3312C23.1333 36.7571 22.3463 34.8263 22.3463 32.5387C22.3463 30.2508 23.1333 28.3198 24.7075 26.7456C26.2817 25.1719 28.2125 24.385 30.5 24.385C32.7875 24.385 34.7183 25.1719 36.2925 26.7456C37.8667 28.3198 38.6538 30.2508 38.6538 32.5387C38.6538 33.4429 38.5223 34.294 38.2594 35.0919C37.9965 35.8894 37.6102 36.6135 37.1006 37.2644L46.4131 46.6013V21.2931L35.9038 9.08688H15.3556C15.1635 9.08688 14.9873 9.16687 14.8269 9.32687C14.6669 9.48729 14.5869 9.66354 14.5869 9.85563V50.1444C14.5869 50.3365 14.6669 50.5127 14.8269 50.6731C14.9873 50.8331 15.1635 50.9131 15.3556 50.9131H40.5C40.96 50.9131 41.305 51.0594 41.535 51.3519C41.765 51.644 41.88 51.9654 41.88 52.3162C41.88 52.6667 41.7608 52.9931 41.5225 53.2956C41.2846 53.5985 40.9438 53.75 40.5 53.75H15.3556ZM30.5 37.8556C32.0354 37.8556 33.3054 37.2771 34.31 36.12C35.315 34.9629 35.8175 33.604 35.8175 32.0431C35.8175 30.6681 35.2919 29.5208 34.2406 28.6012C33.1894 27.6813 31.9425 27.2212 30.5 27.2212C29.0575 27.2212 27.8106 27.6813 26.7594 28.6012C25.7081 29.5208 25.1825 30.6681 25.1825 32.0431C25.1825 33.604 25.685 34.9629 26.69 36.12C27.6946 37.2771 28.9646 37.8556 30.5 37.8556Z"
                            fill="#1C1B1F" />
                    </g>
                </svg>
                <span class="no-data-heading">Your dashboard is currently empty</span>
                <div class="sub-heading-group">
                    <span class="no-data-sub-heading">There’s currently no information to display for your account. When data becomes available, it will appear on this dashboard.</span>
                    <span class="no-data-sub-heading">If you believe this is an error, please contact your administrator.</span>
                </div>

            </div>
        }

        @if ((user()?.commissioner)) {
            <div>
                <h2 class="open-assignments-title">Your Packages</h2>
            </div>
            <div class="dashboard-tables-container">
                <app-dashboard-configurable-package-response-table
                    title="Requested packages"
                    subTitle="Providers have requested these packages."
                    [config]="configForProviderRequestedPackages"
                    [columns]="columnsForCommissionerRequestedPackages"
                />
                <app-dashboard-configurable-package-table
                    title="Offered packages"
                    subTitle="You have offered these packages to providers."
                    linkTo="package"
                    dataSrc="my-packages"
                    [config]="configForCommissionerOfferedPackages"
                    [columns]="columnsForCommissionerOfferedPackages"
                />
            </div>
        }

        @if ((user()?.provider)) {
            <div>
                <h2 class="open-assignments-title">My Packages</h2>
            </div>
            <div class="dashboard-tables-container">
                <app-dashboard-configurable-package-table
                    title="Packages you have accepted"
                    linkTo="package"
                    [config]="configForProviderPackages"
                    [columns]="columnsForProviderPackages"
                />
                <app-dashboard-configurable-package-table
                    title="Packages you have been offered"
                    dataSrc="potential-packages"
                    linkTo="provider-offer"
                    [config]="configForProviderOfferedPackages"
                    [columns]="columnsForProviderOfferedPackages"
                />
                <app-dashboard-configurable-package-response-table
                    title="Packages you have requested"
                    [config]="configForProviderRequestedPackages"
                    [columns]="columnsForProviderRequestedPackages"
                />
                <app-dashboard-configurable-package-response-table
                    title="Packages you have declined"
                    [config]="configForProviderDeclinedPackages"
                    [columns]="columnsForProviderDeclinedPackages"
                />
            </div>
        }
    </ng-template>
</div>
